import React from 'react';

class Settings extends React.Component {
  render() {
    return (
      <header>
        <h1 data-testid="settings-title">
          Trivia
        </h1>
      </header>
    );
  }
}

export default Settings;
